<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        :title='item.data === undefined ? "软著分解" : "软著分解" '
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='500'
      >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-card v-for="(item, idx) in form.softs" :key="idx" class="mb-3" outlined>
              <v-card-title>软著NO.{{idx+1}}</v-card-title>
              <v-card-text>
                <v-row >
                  <v-col cols="12" md="12">
                    <v-text-field
                        hide-details="auto"
                        :key='idx'
                        label="软著名称（未确定可先填‘无’）"
                        outlined
                        :rules="required"
                        v-model="form.softs[idx].name">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-text-field
                        hide-details="auto"
                        :key='idx'
                        label="著作权人"
                        outlined
                        v-model="form.softs[idx].copName">
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { isEmpty } from '@/utils/stringUtil.js'
  import { decp } from '@/api/copyright/software.js'

  export default {
    name: 'OrderDecpEdit',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        form: {
          orderId: '',
          contractId: '',
          customerId: '',
          productId: '',
          softs: [
            {
              name: '',
              copName: ''
            }
          ]
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          decp(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      softNumberInput (val) {
        this.form.softs = []
        for (let i = 0; i < Number(val); i++) {
          this.form.softs.push({ name: '', copName: this.item.data.customer.name })
        }
      },
      dialogChange (val) {
        this.reset()
        this.item.show = val
        if (val && this.isEdit) {
            this.form.orderId = this.item.data.id
            this.form.contractId = this.item.data.contract.id
            this.form.customerId = this.item.data.customer.id
            this.form.productId = this.item.data.contract.productId
            this.softNumberInput(this.item.data.contract.productNumber)
        }
      },
      reset () {
        if (!isEmpty(this.$refs.form)) {
          this.$refs.form.reset()
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
